import PropTypes from 'prop-types';

export const TOP_RATED_2020_LOGO_SRC = '/img/top-rated/top-rated-logo-2020.svg';

export const TOP_RATED_2021_LOGO_SRC = '/img/top-rated/top-rated-logo-2021.svg';

export const TOP_RATED_2022_LOGO_SRC = '/img/top-rated/top-rated-logo-2022.svg';

export const TOP_RATED_2023_LOGO_SRC = '/img/top-rated/top-rated-logo-2023_v1.svg';

export const LAUREL_LEFT_SRC = '/img/top-rated/category-icons/2026/laurel_left.svg';

export const LAUREL_RIGHT_SRC = '/img/top-rated/category-icons/2026/laurel_right.svg';

export const LAUREL_LEFT_HOVER_SRC = '/img/top-rated/category-icons/2026/laurel_left_hover.svg';

export const LAUREL_RIGHT_HOVER_SRC = '/img/top-rated/category-icons/2026/laurel_right_hover.svg';

export const ELECTRIC_BOLT_STROKE_SRC = '/img/top-rated/2026/electric-bolt-stroke.svg';

export const ELECTRIC_BOLT_FILL_SRC = '/img/top-rated/2026/electric-bolt-fill.svg';

export const LT_8_CLASS = 'lt-8';

export const GT_8_CLASS = 'gt-8';

export const LOGO_SOURCE = {
  2024: TOP_RATED_2023_LOGO_SRC,
  2023: TOP_RATED_2023_LOGO_SRC,
  2022: TOP_RATED_2022_LOGO_SRC,
  2021: TOP_RATED_2021_LOGO_SRC,
  2020: TOP_RATED_2020_LOGO_SRC,
};

export const TOP_RATED_BREADCRUMBS = [{ title: 'Home', href: '/' }];

export const HERO_PHOTO_SIZE = {
  MOBILE: 500,
  DESKTOP: 1600,
};

export const VIDEO_CARD_THUMBNAIL_SIZE = 500;

// 4 lines of 16px text
export const TRUNCATED_HTML_HEIGHT = 85;

export const SECTION_RELATED_CONTENT = {
  ASPECT_RATIO: '16:9',
  ITEM_CLASS_NAME: 'mt-1',
  PHOTO_SIZE: 175,
  COLUMN_NUMBER: {
    MOBILE: 2,
    DESKTOP: 4,
  },
  MAX_CONTENT_LENGTH: {
    MOBILE: 2,
    DESKTOP: 4,
  },
};

export const RELATED_CONTENT_CONFIG = {
  ASPECT_RATIO: '16:9',
  ITEM_CLASS_NAME: 'mt-2',
  PHOTO_SIZE: 300,
  COLUMN_NUMBER: {
    MOBILE: 2,
    DESKTOP: 3,
  },
  MAX_CONTENT_LENGTH: {
    MOBILE: 4,
    DESKTOP: 6,
  },
};

export const BUTTONS_DEFAULT_TITLE = {
  PRIMARY: 'Pricing & Reviews',
  SECONDARY: 'See Rankings',
};

export const LinkDataPropType = PropTypes.shape({
  title: PropTypes.string,
  url: PropTypes.string,
  nofollow: PropTypes.bool,
  blank: PropTypes.bool,
});

export const BASE_COLORS = {
  'text-white': {
    2021: 'text-white',
    2022: 'text-gray-darker',
    2023: 'cool-gray-100',
    2024: 'cool-gray-100',
    2025: 'text-white',
    2026: 'text-white',
  },
  'text-gray': {
    2021: 'text-gray',
    2022: 'text-gray-dark',
    2023: 'cool-gray-100',
    2024: 'cool-gray-100',
    2025: 'cool-gray-100',
    2026: 'cool-gray-100',
  },
};

export const WINNERS_2023_MAPPING = [
  '/best-of-the-best',
  '/car',
  '/electric-car',
  '/suv',
  '/electric-suv',
  '/truck',
  '/electric-truck',
];
